import type { JSX } from 'react';
import { useNavigate } from 'react-router-dom';
import { ErrorPageShell } from '../../error/ErrorPageShell';
import { ErrorStateCard } from '../../error/ErrorStateCard';
import { ROUTE_PATHS } from '../../routes/routePaths';

export function DownloadSuccess(): JSX.Element {
  const navigate = useNavigate();

  return (
    <ErrorPageShell secondaryText="" secondaryActionLabel="" additionalText="">
      <ErrorStateCard
        icon="bi-search"
        badgeIcon="bi-file-earmark"
        illustration="not-found"
        title="Downloaded successfully"
        logPayload={null}
        retryLabel="Try again"
        goHomeLabel="Go Home"
        onGoHome={() => navigate(ROUTE_PATHS.CATEGORY_HOME)}
        description="You can close this window now."
      />
    </ErrorPageShell>
  );
}

export default DownloadSuccess;
